export const TITLE =
  'Submit medical expenses to support a pension or parents’ D.I.C. claim';
export const SUBTITLE = 'Medical Expense Report (VA Form 21P-8416)';
